<script>
export default {
  name: 'NonDynamicTransport',
};
</script>

<template>
  <router-view></router-view>
</template>



// WEBPACK FOOTER //
// src/pages/non-dynamic-transport/NonDynamicTransport.vue